export default "__VITE_ASSET__DwXAB2kw__$_?url__"